import { jsx as _jsx } from "react/jsx-runtime";
import { Fab } from "@mui/material";
import { forwardRef } from "react";
export const UiFab = forwardRef((props, ref) => (_jsx(Fab, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_fab.js.map